import { Alert, List, Stack, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useSyncStatus } from '../../app/services';
import { Copy } from '../../ui/Brand';
import { ActionButton, Part } from '../../ui/SettingsParts';

const when = (ms: number | null) => (ms ? new Date(ms).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : 'not yet');

/** Settings → Account: what's synced, what's waiting, and anything the server refused. */
export const SyncCard = () => {
  const sync = useSyncStatus();
  if (!sync) return null;
  const { status: s, syncNow } = sync;
  return (
    <Part
      title="Sync"
      lead="Your tournaments, flows and ballots sync between your devices, usually within seconds. Debater names stay on the device they were entered on."
      actions={<ActionButton leftSection={<IconRefresh size={14} />} loading={s.state === 'syncing'} onClick={() => void syncNow()} data-testid="sync-now">Sync now</ActionButton>}
      testId="sync-card"
    >
      <Stack gap="sm">
        <Text size="sm">
          Last synced: <b data-testid="sync-last">{when(s.lastSyncAt)}</b>
          {' · '}Waiting to sync: <b data-testid="sync-pending">{s.pending}</b>
        </Text>
        {s.state === 'offline' && <Text size="sm" c="dimmed">Offline. Changes sync when you're back online.</Text>}
        {(s.state === 'error' || s.state === 'off') && s.message && <Text size="sm" c="yellow.8"><Copy>{s.message}</Copy></Text>}
        {s.rejected.length > 0 && (
          <Alert color="red" title={`${s.rejected.length} change${s.rejected.length === 1 ? ' was' : 's were'} refused by the server`}>
            <Text size="xs" mb={4}>They're still on this device; they didn't reach your other devices.</Text>
            <List size="xs">
              {s.rejected.slice(0, 10).map((r, i) => <List.Item key={i}>{r.kind} {r.recordId.slice(0, 8)}: {r.message}</List.Item>)}
            </List>
          </Alert>
        )}
      </Stack>
    </Part>
  );
};
